import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

// Social icons are intentionally hidden until real profile URLs exist.
// To enable later, populate this array with { label, href, Icon } entries and
// render inside the footer's social slot.
export const SOCIAL_LINKS = [];

const COLS = [
  {
    heading: "Service",
    links: [
      { label: "How It Works", href: "/#how-it-works" },
      { label: "What's Included", href: "/#included" },
      { label: "Website Examples", href: "/#demos" },
    ],
  },
  {
    heading: "Details",
    links: [
      { label: "Pricing", href: "/#pricing" },
      { label: "FAQ", href: "/#faq" },
      { label: "Get My Website", href: "/#lead-form" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy", route: true },
      { label: "Terms", href: "/terms", route: true },
    ],
  },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-goc-navy text-white"
      data-testid="site-footer"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Logo variant="light" />
            <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-xs">
              Your business website, handled.
            </p>
            <p className="mt-6 text-xs text-white/50">GetOnlineCrew.com</p>
          </div>

          {COLS.map((col) => (
            <div key={col.heading}>
              <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-widest">
                {col.heading}
              </h3>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.route ? (
                      <Link
                        to={l.href}
                        className="text-sm text-white/70 hover:text-white transition-colors"
                        data-testid={`footer-link-${l.label
                          .toLowerCase()
                          .replace(/[^a-z0-9]+/g, "-")}`}
                      >
                        {l.label}
                      </Link>
                    ) : (
                      <a
                        href={l.href}
                        className="text-sm text-white/70 hover:text-white transition-colors"
                        data-testid={`footer-link-${l.label
                          .toLowerCase()
                          .replace(/[^a-z0-9]+/g, "-")}`}
                      >
                        {l.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            &copy; {year} Get Online Crew. All rights reserved.
          </p>
          {/* Social icon slot: hidden until real profile URLs are configured. */}
          {SOCIAL_LINKS.length > 0 ? (
            <ul className="flex items-center gap-4">
              {SOCIAL_LINKS.map(({ label, href, Icon }) => (
                <li key={label}>
                  <a
                    href={href}
                    aria-label={label}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
